import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { forkJoin } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-credit-debit-ledger-report',
  templateUrl: './credit-debit-ledger-report.component.html',
  styleUrls: ['./credit-debit-ledger-report.component.scss'],
})
export class CreditDebitLedgerReportComponent implements OnInit {
  creditdebitledgerData = [];
  bankwiseData;
  creditledgerData;
  debitledgerData;
  debittotal = 0.0;
  credittotal = 0.0;
  previousbaki = 0.0;
  nextbaki = 0.0;
  startDate;
  endDate;
  startDate1;
  endDate1;
  bank;
  bankname: number;
  contraData: any;
  contraTotal: any
  creditTotal: any
  debitTotal: any
  obalance: any
  crOpeningBal: number = 0;
  drOpeningBal: number = 0;
  drTotal: any;
  crTotal: number;

  constructor(
    private dialogref: MatDialogRef<CreditDebitLedgerReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.bank = this.data['bank'];

    if (this.startDate !== '2024-04-01') {
      this.startDate1 = '2024-04-01';

      const start = new Date(this.startDate);
      const dayBefore = new Date(start.setDate(start.getDate() - 1));

      const year = dayBefore.getFullYear();
      const month = String(dayBefore.getMonth() + 1).padStart(2, '0');
      const date = String(dayBefore.getDate()).padStart(2, '0');

      this.endDate1 = `${year}-${month}-${date}`;

      this.getOpeningBal();

      // Wait for 1 second (1000 ms) before calling getAllCreditVouchers
      setTimeout(() => {
        this.getAllCreditVouchers();
      }, 5000);
    } else {
      this.getAllCreditVouchers();
    }
  }


  getOpeningBal() {

    const req: any = {
      startdate: this.startDate1,
      enddate: this.endDate1,
      startdate1: this.startDate1,
      enddate1: this.endDate1,
      banktype: this.bank,
    };

    forkJoin({
      contraData: this.service.getAllcontra(req),
      creditData: this.service.getAllCreditVouchersData(this.startDate1, this.endDate1, this.bank),
      debitData: this.service.getAllDebitVouchersData(this.startDate1, this.endDate1, this.bank),
    }).subscribe(({ contraData, creditData, debitData }) => {

      // Ensure arrays before merging
      const safeContraData = Array.isArray(contraData) ? contraData : [];
      const safeCreditData = Array.isArray(creditData) ? creditData : [];
      const safeDebitData = Array.isArray(debitData) ? debitData : [];
      debugger
      // Sum deposit amounts from each
      this.contraTotal = safeContraData.reduce((sum, item) => sum + (parseFloat(item.deposit_amt) || 0), 0);
      this.creditTotal = safeCreditData.reduce((sum, item) => sum + (parseFloat(item.deposit_amt) || 0), 0);
      this.debitTotal = safeDebitData.reduce((sum, item) => sum + (parseFloat(item.deposit_amt) || 0), 0);

    });

  }

  getAllCreditVouchers() {
    if (this.startDate !== '' && this.endDate !== '' && this.bank !== '') {
      // Fetch bank opening balance
      this.service.readBankwiseOpeningBalance(this.bank).subscribe((res) => {
        this.bankwiseData = res;
        debugger;
        if (this.startDate !== '2024-04-01') {
          const openingBal = Number(this.bankwiseData['opening_bal']) || 0;
          const contra = parseFloat(this.contraTotal) || 0;
          const credit = parseFloat(this.creditTotal) || 0;
          const debit = parseFloat(this.debitTotal) || 0;

          if (this.bankwiseData['crdt_debt'] === 'Dr') {
            this.drTotal = (parseFloat(this.bankwiseData['opening_bal']) + contra + credit) * -1;
            this.crTotal = debit;
          } else {
            this.crTotal = parseFloat(this.bankwiseData['opening_bal']) + debit;
            this.drTotal = (contra + credit) * -1;
          }

          debugger

          this.obalance = this.drTotal + this.crTotal;

          debugger

          if (this.obalance > 0) {
            this.crOpeningBal = parseFloat(this.obalance);
            this.previousbaki = this.crOpeningBal;
          } else {
            this.drOpeningBal = parseFloat(this.obalance);
            this.previousbaki = this.drOpeningBal;
          }
        } else {
          this.obalance = this.bankwiseData['opening_bal'];
          if (this.bankwiseData['crdt_debt'] === 'Dr') {
            this.drOpeningBal = parseFloat(this.obalance) * -1;
            this.previousbaki = this.drOpeningBal;
          } else {
            this.crOpeningBal = this.obalance;
            this.previousbaki = this.crOpeningBal;
          }
        }

        this.bankname = this.bankwiseData['sub_exp_name'];

        const req: any = {
          startdate: this.startDate,
          enddate: this.endDate,
          banktype: this.bank,
        };

        // Fetch all data in parallel
        forkJoin({
          contraData: this.service.getAllcontra(req),
          creditData: this.service.getAllCreditVouchersData(this.startDate, this.endDate, this.bank),
          debitData: this.service.getAllDebitVouchersData(this.startDate, this.endDate, this.bank),
        }).subscribe(({ contraData, creditData, debitData }) => {
          this.creditdebitledgerData = [];

          const safeContraData = Array.isArray(contraData) ? contraData : [];
          const safeCreditData = Array.isArray(creditData) ? creditData : [];
          const safeDebitData = Array.isArray(debitData) ? debitData : [];

          // Set types if not already
          safeContraData.forEach((v: any) => v.type = 'contra');
          safeCreditData.forEach((v: any) => v.type = 'Cr');
          safeDebitData.forEach((v: any) => v.type = 'Dr');

          const combinedData = [...safeContraData, ...safeCreditData, ...safeDebitData];

          // Sort by voucher_date, then by type (CR first, then DR, then contra if needed)
          combinedData.sort((a, b) => {
            const dateA = new Date(a.voucher_date).getTime();
            const dateB = new Date(b.voucher_date).getTime();

            if (dateA !== dateB) {
              return dateA - dateB;
            }

            const getTypeOrder = (type: string) => {
              if (type === 'Cr') return 1;
              if (type === 'Dr') return 2;
              if (type === 'contra') return 3;
              return 4;
            };

            return getTypeOrder(a.type) - getTypeOrder(b.type);
          });
          debugger
          combinedData.forEach((a) => {
            if (this.bank === 'JSBP' || this.bank === 'JSBL' || this.bank === 'TJSBOD') {
              if (a.type === 'Cr') {
                this.previousbaki -= parseFloat(a.deposit_amt);
              } else if (a.type === 'contra') {
                this.previousbaki -= parseFloat(a.deposit_amt);
              } else {
                this.previousbaki += parseFloat(a.deposit_amt);
              }
            } else {
              if (a.type === 'Cr') {
                this.previousbaki -= parseFloat(a.deposit_amt);
              } else if (a.type === 'contra') {
                this.previousbaki -= parseFloat(a.deposit_amt);
              } else {
                this.previousbaki += parseFloat(a.deposit_amt);
              }
            }

            this.creditdebitledgerData.push({
              ...a,
              total: this.previousbaki,
              type: a.type === 'Dr' ? 'CR' : 'DR', // reverse for display
            });
          });

          this.calculatecrdtdebtVouchersData();
        });
      });
    }
  }

  calculatecrdtdebtVouchersData() {
    // Initialize totals
    this.debittotal = 0.0;
    this.credittotal = 0.0;

    debugger

    // Include opening balance
    if (this.bankwiseData?.crdt_debt === 'Cr') {
      this.credittotal = Number(this.crOpeningBal);
    } else if (this.bankwiseData?.crdt_debt === 'Dr') {
      this.debittotal = Number(this.drOpeningBal);
    }

    // Ensure data is valid
    if (Array.isArray(this.creditdebitledgerData)) {
      this.creditdebitledgerData.forEach((item) => {
        const depositAmt = parseFloat(item?.deposit_amt || '0');

        if (!isNaN(depositAmt)) {
          if (item.type === 'DR') {
            this.debittotal -= depositAmt;  // Sum of डेबिट column
          } else if (item.type === 'CR') {
            this.credittotal += depositAmt; // Sum of क्रेडिट column
          }
        }
      });
    }

    debugger

    // Calculate remaining balance
    this.nextbaki = this.debittotal + this.credittotal;

  }

  toInt(amt) {
    return parseFloat(amt);
  }

  exportExcel(fileName: string): void {
    // local helper: format date dd-MM-yyyy
    const fmt = (d: any) => {
      if (!d) return '';
      try {
        const dt = new Date(d);
        const parts = dt.toLocaleDateString('en-GB').split('/');
        return `${parts[0]}-${parts[1]}-${parts[2]}`;
      } catch {
        return String(d);
      }
    };

    // Build rows as objects (json_to_sheet)
    const rows: Array<Record<string, any>> = [];

    // Header: left / center / right like your template
    const todayStr = (this as any).getFormattedDate ? (this as any).getFormattedDate() : fmt(new Date());
    rows.push({ 'सांकेतांक': `दिनांक : ${todayStr}`, 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });
    rows.push({ 'सांकेतांक': `पृष्ठ क्र : 1`, 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });
    rows.push({ 'सांकेतांक': '', 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });

    // Center title block (kept Marathi text)
    rows.push({ 'सांकेतांक': 'हिंदुस्थान प्रकाशन संस्था', 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });
    rows.push({ 'सांकेतांक': 'विवेक साप्ताहिक', 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });
    rows.push({ 'सांकेतांक': 'मुख्य खाते अनूपुस्तिका', 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });

    // Report title / bank name and date range
    const title = (this as any).expName ?? '';
    const subtitle = (this as any).subExpName ? ` - ${(this as any).subExpName}` : '';
    rows.push({ 'सांकेतांक': `** ${title}${subtitle} **`, 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });
    rows.push({ 'सांकेतांक': `तपशील : ${this.bankname ?? ''}`, 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });
    rows.push({
      'सांकेतांक': `दिनांक पासून : ${this.startDate ? fmt(this.startDate) : ''}`,
      'दिनांक': `दिनांक पर्यंत : ${this.endDate ? fmt(this.endDate) : ''}`,
      'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': ''
    });
    rows.push({ 'सांकेतांक': '', 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });

    // Column headers
    rows.push({ 'सांकेतांक': 'सांकेतांक', 'दिनांक': 'दिनांक', 'तपशील': 'तपशील', 'डेबिट': 'डेबिट', 'क्रेडिट': 'क्रेडिट', 'रक्कम': 'रक्कम' });

    // Opening balance row (मागील बाकी) — match your template logic:
    // template showed drOpeningBal * -1 under Debit, crOpeningBal under Credit
    const drOpening = (this.drOpeningBal !== undefined && this.drOpeningBal !== null && this.drOpeningBal !== 0)
      ? Number((this.drOpeningBal * -1).toFixed(2))
      : '';
    const crOpening = (this.crOpeningBal !== undefined && this.crOpeningBal !== null && this.crOpeningBal !== 0)
      ? Number(Number(this.crOpeningBal).toFixed(2))
      : '';

    rows.push({
      'सांकेतांक': '',
      'दिनांक': '',
      'तपशील': 'मागील बाकी :',
      'डेबिट': drOpening,
      'क्रेडिट': crOpening,
      'रक्कम': ''
    });

    // Ledger rows (mirror *ngFor)
    const ledger = Array.isArray(this.creditdebitledgerData) ? this.creditdebitledgerData : [];
    ledger.forEach((item: any) => {
      const voucherNo = item?.voucher_no ?? '';
      const cheque = item?.cheque ?? '';
      const voucherDate = item?.voucher_date ? fmt(item.voucher_date) : '';

      // build details: rep_name, other_name small, narration in parentheses
      const parts: string[] = [];
      if (item?.rep_name) parts.push(item.rep_name);
      if (item?.other_name) parts.push(item.other_name);
      if (item?.narration) parts.push(`(${item.narration})`);
      const detail = parts.join(' ');

      // deposit_amt placed into Debit or Credit based on displayed `type` in ledger
      const depositAmtRaw = (item?.deposit_amt !== undefined && item.deposit_amt !== null && item.deposit_amt !== '')
        ? Number(item.deposit_amt)
        : null;

      const debitCell = (item?.type === 'DR' && depositAmtRaw !== null && !isNaN(depositAmtRaw)) ? Number(depositAmtRaw.toFixed(2)) : '';
      const creditCell = (item?.type === 'CR' && depositAmtRaw !== null && !isNaN(depositAmtRaw)) ? Number(depositAmtRaw.toFixed(2)) : '';

      // total column: negative => show as positive + " Dr", positive/zero => " Cr" (keeps same string format as template)
      const totalNum = this.getFinalTotalNumber(item?.total);
      const totalLabel = (typeof totalNum === 'number') ? (totalNum < 0 ? `${Math.abs(Number(totalNum.toFixed(2)))} Dr` : `${Number(totalNum.toFixed(2))} Cr`) : '';

      rows.push({
        'सांकेतांक': voucherNo + (cheque ? ` (${cheque})` : ''),
        'दिनांक': voucherDate,
        'तपशील': detail,
        'डेबिट': debitCell,
        'क्रेडिट': creditCell,
        'रक्कम': totalLabel
      });
    });

    // Totals row (your template used debittotal * -1 and credittotal as-is)
    const drTotal = (this.debittotal !== undefined && this.debittotal !== null) ? Number(this.debittotal) : 0;
    const crTotal = (this.credittotal !== undefined && this.credittotal !== null) ? Number(this.credittotal) : 0;

    rows.push({
      'सांकेतांक': '',
      'दिनांक': '',
      'तपशील': 'एकूण :',
      'डेबिट': parseFloat((drTotal * -1).toFixed(2)),
      'क्रेडिट': parseFloat(Number(crTotal).toFixed(2)),
      'रक्कम': ''
    });

    // baki pudhe (nextbaki): show numeric in Debit or Credit and text in रक्कम
    const nextb = (this.nextbaki !== undefined && this.nextbaki !== null) ? Number(this.nextbaki) : 0;
    rows.push({
      'सांकेतांक': '',
      'दिनांक': '',
      'तपशील': 'बाकी पुढे :',
      'डेबिट': nextb < 0 ? Math.abs(Number(nextb.toFixed(2))) : '',
      'क्रेडिट': nextb >= 0 ? Number(nextb.toFixed(2)) : '',
      'रक्कम': nextb < 0 ? `${Math.abs(Number(nextb.toFixed(2)))} Dr` : `${Number(nextb.toFixed(2))} Cr`
    });

    // final blank footer row
    rows.push({ 'सांकेतांक': '', 'दिनांक': '', 'तपशील': '', 'डेबिट': '', 'क्रेडिट': '', 'रक्कम': '' });

    // Create worksheet & workbook
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });

    // set column widths for readability
    (ws as any)['!cols'] = [
      { wch: 20 }, // संकेतांक
      { wch: 14 }, // दिनांक
      { wch: 60 }, // तपशील
      { wch: 14 }, // डेबिट
      { wch: 14 }, // क्रेडिट
      { wch: 18 }  // रक्कम
    ];

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Ledger');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }


  // Helper: extract numeric total (works with numbers, "123.45 Dr"/"123.45 Cr" strings, negative numbers)
  private getFinalTotalNumber(totalField: any): number {
    if (totalField === null || totalField === undefined || totalField === '') return 0;
    if (typeof totalField === 'number') return totalField;
    if (typeof totalField === 'string') {
      const m = totalField.match(/-?\d+(\.\d+)?/);
      if (m) return Number(m[0]);
      return 0;
    }
    const parsed = Number(totalField);
    return isNaN(parsed) ? 0 : parsed;
  }

}